// Channel Read Actions - ES2015 Module Syntax
import { ChannelRead } from '../../models/chat.models';

// Load Actions
export class LoadChannelReads {
    static readonly type = '[ChannelRead] Load Channel Reads';
    constructor(
        public userId: string,
        public limit?: number,
        public nextToken?: string,
    ) {}
}

export class LoadChannelReadsSuccess {
    static readonly type = '[ChannelRead] Load Channel Reads Success';
    constructor(
        public channelReads: ChannelRead[],
        public nextToken?: string,
    ) {}
}

export class LoadChannelReadsError {
    static readonly type = '[ChannelRead] Load Channel Reads Error';
    constructor(public error: any) {}
}

// CRUD Actions
export class UpdateChannelRead {
    static readonly type = '[ChannelRead] Update Channel Read';
    constructor(public channelRead: ChannelRead) {}
}

// Mutation Actions
export class MarkChannelAsRead {
    static readonly type = '[ChannelRead] Mark Channel As Read';
    constructor(
        public channelId: string,
        public userId: string,
        public lastReadMessageId: string,
    ) {}
}

export class IncrementUnreadCount {
    static readonly type = '[ChannelRead] Increment Unread Count';
    constructor(
        public channelId: string,
        public userId: string,
        public increment = 1,
    ) {}
}

export class DecrementUnreadCount {
    static readonly type = '[ChannelRead] Decrement Unread Count';
    constructor(
        public channelId: string,
        public userId: string,
        public decrement = 1,
    ) {}
}

export class ResetUnreadCount {
    static readonly type = '[ChannelRead] Reset Unread Count';
    constructor(
        public channelId: string,
        public userId: string,
    ) {}
}

// Utility Actions
export class ClearChannelReads {
    static readonly type = '[ChannelRead] Clear Channel Reads';
}
